import _toConsumableArray from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\vdsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\vdsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import './InterestsStep.css';
import React, { useEffect, useState } from 'react';
import TagsSelector from '../atoms/TagsSelector/TagsSelector';
var InterestsStep = function InterestsStep(_ref) {
  var choiceItems = _ref.choiceItems,
    description = _ref.description,
    onDataChange = _ref.onDataChange,
    initData = _ref.initData,
    title = _ref.title;
  var _useState = useState(initData.selectedIds),
    _useState2 = _slicedToArray(_useState, 2),
    selectedIds = _useState2[0],
    setSelectedId = _useState2[1];
  var onChange = function onChange(selectedId) {
    if (selectedIds.includes(selectedId)) {
      setSelectedId(selectedIds.filter(function (id) {
        return selectedId !== id;
      }));
    } else {
      setSelectedId([].concat(_toConsumableArray(selectedIds), [selectedId]));
    }
  };
  useEffect(function () {
    onDataChange({
      selectedIds: selectedIds
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedIds]);
  return /*#__PURE__*/React.createElement("div", {
    className: commonStyles
  }, /*#__PURE__*/React.createElement("h2", {
    className: "interests-step__title"
  }, title), /*#__PURE__*/React.createElement("div", {
    className: "interests-step__description"
  }, description), /*#__PURE__*/React.createElement(TagsSelector, {
    className: "interests-step__tags-selector",
    items: choiceItems,
    selectedIds: selectedIds,
    onChange: onChange,
    limit: 3
  }));
};
export default InterestsStep;
var commonStyles = "coyncd4";